<template>
  <div>
    <Card>
      <Row style="margin-bottom: 10px">
        <Button type="info"
                @click="add">{{$t('pages_combo_index_276')}}</Button>
      </Row>
      <i-table :columns="columns"
               :data="enough_consume_discounts"
               :loading="loading">
        <template slot="rules"
                  slot-scope="{ row }">
          <p v-for="(rule, index) in ruleList(row)"
             :key="index"><b>{{index + 1}}.</b> {{ rule }}</p>
        </template>

        <template slot="is_running"
                  slot-scope="{ row }">
          <tag color="green"
               v-if="row.is_running">{{$t('pages_combo_index_277')}}</tag>
          <tag v-else>{{$t('pages_combo_index_278')}}</tag>
        </template>
        <template slot="start_at"
                  slot-scope="{ row }">
          {{ fmt(row.start_at) }}
        </template>
        <template slot="end_at"
                  slot-scope="{ row }">
          {{ fmt(row.end_at) }}
        </template>
      </i-table>
      <Page :total="meta.total"
            :current="meta.current"
            show-total
            :page-size="meta.pageSize"
            @on-change="changePage"></Page>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           width="660"
           :title="$t('pages_enough_consume_discount_index_482')">
      <Form ref="enough_consume_discount"
            :model="form"
            :label-width="80">
        <Form-Item :label="$t('pages_combo_index_280')"
                   prop="name">
          <Input :placeholder="$t('pages_combo_index_281')"
                 v-model="form.name" />
        </Form-Item>
        <Form-item :label="$t('pages_banners_index_185')">
          <Select label-in-value
                  :disabled="!!form.id"
                  @on-change="change_category"
                  v-model="form.category">
            <Option v-for="item in activity_categories"
                    :value="item.code"
                    :key="item.code">{{ item.text }}</Option>
          </Select>
        </Form-item>
        <Form-Item :label="$t('pages_enough_consume_discount_index_483')"
                   prop="rules">
          <RuleList :category="form.category"
                    v-model="form.rules" />
        </Form-Item>
        <Form-Item :label="$t('pages_enough_consume_discount_index_484')"
                   prop="start_at">
          <Date-Picker type="datetime"
                       v-model="form.start_at" />
        </Form-Item>
        <Form-Item :label="$t('pages_enough_consume_discount_index_485')"
                   prop="end_at">
          <Date-Picker type="datetime"
                       v-model="form.end_at" />
        </Form-Item>
      </Form>
      <template slot="footer">
        <i-button @click="modalShow = false"
                  type="text"
                  style="margin-right: 12px">{{$t('pages_city_shop_freights_index_250')}}</i-button>
        <i-button @click="handleSubmit"
                  type="primary">{{$t('pages_combo_index_284')}}</i-button>
      </template>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapActions, mapMutations, mapState } from 'vuex'
// import TablePaginate from '@/components/TablePaginate'
import moment from 'moment';
import { deleteButtonInTable, editorButtonInTable, toggleRunButtonInTable } from '@/libs/table-render'
import RuleList from './rule-list';

const getDefaults = () => {
  return {
    category: 'amount',
    name: '',
    rules: [],
    start_at: '',
    end_at: '',
    description: ''
  };
}

export default {
  components: {
    // TablePaginate,
    RuleList
  },
  watch: {
    enough_consume_discount (val) {
      if (val && val.id) {
        this.form = {
          ...val,
          rules: val.rules || [],
        };
      }
    }
  },
  data () {
    return {
      activity_categories: [
        { text: i18n.t('pages_combo_index_285'), code: i18n.t('pages_combo_index_285') },
        { text: i18n.t('pages_combo_index_286'), code: i18n.t('pages_combo_index_286') }
      ],
      form: getDefaults(),
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_booking_store_products_index_220'),
          key: 'category',
          width: 180
        },
        {
          title: i18n.t('pages_combo_index_280'),
          key: 'name',
          width: 300,
          // width: 120,
          // align: 'center',
        },
        {
          title: i18n.t('pages_enough_consume_discount_index_483'),
          key: 'rules',
          width: 200,
          // align: 'center',
          slot: 'rules'
        },
        {
          title: i18n.t('pages_balance_transaction_index_176'),
          width: 120,
          key: 'is_running',
          slot: 'is_running',
        },
        {
          title: i18n.t('pages_enough_consume_discount_index_484'),
          key: 'start_at',
          width: 200,
          slot: 'start_at',
        },
        {
          title: i18n.t('pages_enough_consume_discount_index_485'),
          key: 'end_at',
          width: 200,
          slot: 'end_at'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 300,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            children.push(toggleRunButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapState('enough_consume_discount', ['enough_consume_discount', 'enough_consume_discounts', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('enough_consume_discount', [
      'index',
      'show',
      'create',
      'update',
      'destroy',
      'toggleRun'
    ]),
    ...mapMutations('enough_consume_discount', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    change_category (e) {
      this.form.category = e.value
    },
    add () {
      this.form = getDefaults()
      this.modalShow = true
      this.formType = 'new'
    },
    toggleRunning (row) {
      this.toggleRun(row.id).then(() => {
        this.$Message.success(i18n.t('pages_combo_index_287'));
        this.index({ page: this.meta.page })
      }, (e) => {
        const message = ((e.response && e.response.data) && e.response.message) || i18n.t('pages_combo_index_288');
        this.$Message.error(message);
      });
    },
    async handleSubmit () {
      const payload = { ...this.form };
      payload.start_at = moment(payload.start_at).format('YYYY-MM-DD HH:mm:ss');
      payload.end_at = moment(payload.end_at).format('YYYY-MM-DD HH:mm:ss');

      if (moment(payload.start_at).isAfter(moment(payload.end_at))) {
        this.$Message.error(i18n.t('pages_enough_consume_discount_index_486'));
        return;
      }

      if (this.formType === 'edit') {
        await this.update(payload)
      } else if (this.formType === 'new') {
        await this.create(payload)
      }
      this.index({ page: this.meta.page })
      this.modalShow = false
    },
    ruleList (row) {
      if (row.category === i18n.t('pages_combo_index_285')) {
        return row.rules.map(i => {
          return i18n.t('pages_enough_consume_discount_index_487', [i.enough,i.cut]);
        });
      } else {
        return row.rules.map(i => {
          return i18n.t('pages_enough_consume_discount_index_488', [i.enough,i.cut]);
        });
      }
    },
    fmt (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
